import $ from 'jquery';

function callApi(data) {
  const $callAjaxDeferred = new $.Deferred();
  $.ajax({
    url: data,
    dataType: 'json'
  }).success(function (response, statusText, data) {
    if (statusText === 'success') {
      $callAjaxDeferred.resolve(response);
    } else {
      console.error('Bad response data.');
    }
  }).fail(function(error) {
    console.log('Failed to load Data', error);
  });
  return $callAjaxDeferred;
}

function datePager(ctx, cnt) {
  const $ctx = ctx;
  const $list = $ctx.find('.list_date li');
  const len = $list.length;
  const $on = $list.filter('.on');
  const onIdx = $on.index();
  const $wrapBtn = $ctx.find('.wrap_btn');
  const $btnPrev = $wrapBtn.find('.btn_prev');
  const $btnNext = $wrapBtn.find('.btn_next');
  const viewCount = Math.ceil(len / cnt) - 1;
  let currentIdx = parseInt(onIdx / cnt);

  $btnPrev.on('click', function () {
    if (currentIdx !== 0) {
      currentIdx -= 1;
      toggleClass();
    } else {
      return;
    }
    arrowClass();
  });
  $btnNext.on('click', function () {
    if (viewCount > currentIdx) {
      currentIdx += 1;
      toggleClass();
      $(this).removeClass('btn_off');
    } else {
      return;
    }
    arrowClass();
  });
  function toggleClass() {
    $list.each(function (index) {
      const $this = $(this);
      currentIdx === parseInt(index / cnt) ? $this.removeClass('hide') : $this.addClass('hide');
    });
  }
  function arrowClass() {
    currentIdx === 0 ? $btnPrev.addClass('btn_off') : $btnPrev.removeClass('btn_off');
    currentIdx === viewCount ? $btnNext.addClass('btn_off') : $btnNext.removeClass('btn_off');
  }
}


function clipPlayer(container, videoId) {
  const playerContainer = document.getElementById(container);
  const clipLinkId = videoId;
  const profile = 'HIGH';
  const playerConfig = {
    type: 'VOD',
    service: 'daum_searchview',
    id: clipLinkId + '@my',
    profile: profile,
    kakaotv: 0,
    wmode: 'opaque',
    autoplay: 1,
    fs: 1,
  };
  const player = KTP.Player.create(playerContainer, playerConfig);
  player.load(clipLinkId, profile);
}
export { callApi, datePager, clipPlayer };



/** WEBPACK FOOTER **
 ** ./src/TVP/util.js
 **/